<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <trip-control></trip-control>
      <trip-view page="trip"></trip-view>
    </v-layout>
  </v-container>
</template>

<script>
import TripControl from "@/components/trips/tripControl";
import TripView from "@/components/trips/tripView";
export default {
  components: {
    TripControl,
    TripView
  }
};
</script>

<style>
</style>
